import { render, staticRenderFns } from "./LabSeparatingComponentsOfAMixture.vue?vue&type=template&id=449751da&"
import script from "./LabSeparatingComponentsOfAMixture.vue?vue&type=script&lang=ts&"
export * from "./LabSeparatingComponentsOfAMixture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports